import { createSlice } from '@reduxjs/toolkit';
import { makePayment, makeReservation, makeTokenization } from './api';

const initialState = {
  loading: false,
  isChecked: true,
  signInOpen: false,
  cancellationIsOpen: false,
  // petIsOpen: false,
  termsAndConditionIsOpen: false,
  openPayInfo: false,
  isSignInOption: true,
  paymentMethod: 'card',
  paymentMode: 'fuesbox',
  //this is for single room
  costSItems: [
    {
      packageName: 'Room Cost',
      amount: '0.00',
      amt: 0,
      type: 'roomCost',
    },
    {
      packageName: 'Taxes & Fees',
      amount: '0.00',
      amt: 0,
      type: 'taxesAndFees',
    },
  ],
  //for multiple room
  costSItems2: [
    {
      room : "Room 1",
      costItems : [
        {
          packageName: 'Room Cost',
          amount: '0.00',
          amt: 0,
          type: 'roomCost',
        },
        {
          packageName: 'Taxes & Fees',
          amount: '0.00',
          amt: 0,
          type: 'taxesAndFees',
        },
      ]
    },
  ],
  totalCost: 0,
  amount: 0,
  data: {},
  bookingData: [],
  guestInfo: {},
  paymentResData: {},
  reservationRespData: [],
  reservationStatus: null,
  expectedReservations: 0,
  packagesAndRoomTotalCost: null,
  status: {
    apiMessage: '',
    apiSuccess: true,
  },
  formFieldInitialState: {
    firstName: '',
    lastName: '',
    email: '',
    countryCodeForMobileNumber: '+1',
    mobileNoWithoutCountryCode: '',
    name: '',
    card: '',
    expiryDate: '',
    cvv: '',
    country: { value: 'US', label: 'United States' },
    zipCode: '',
    isUsrProfileNotFoundGpay: false,
  },
  failedReservations: 0,
  // Additional Guests (per-room) and connecting-rooms preference
  additionalGuests: [],
  connectingRoomsPreferred: false,
  // Per-room field-level errors for additional guests
  additionalGuestErrors: [],
};
export const costSummarySlice = createSlice({
  name: 'costSummary',
  initialState,
  reducers: {
    setIsChecked: (state, action) => {
      state.isChecked = action.payload;
    },
    setSignInOpen: (state, action) => {
      state.signInOpen = action.payload;
    },
    setCancellationIsOpen: (state, action) => {
      state.cancellationIsOpen = action.payload;
    },
    // setPetIsOpen: (state, action) => {
    //   state.petIsOpen = action.payload;
    // },
    setOpenPayInfo: (state, action) => {
      state.openPayInfo = action.payload;
    },
    setIsSignInOption: (state, action) => {
      state.isSignInOption = action.payload;
    },
    setPaymentMethod: (state, action) => {
      state.paymentMethod = action.payload;
    },
    setPaymentMode: (state, action) => {
      state.paymentMode = action.payload;
    },
    setCostSItems: (state, action) => {
      state.costSItems = action.payload;
    },
    setCostSItems2: (state, action) => {
      const { room, costItems } = action.payload;
      const foundIndex = state.costSItems2.findIndex(
        (costItem) => costItem.room === room
      );

      if (foundIndex !== -1) {
        // Room already exists – replace the costItems for that room
        state.costSItems2[foundIndex].costItems = costItems;
      }else{
        state.costSItems2.push({ room, costItems });
      }
    },
    updateCostItems: (state, { payload }) => {
      const { room, costItems } = payload;
      if (state.costSItems2[room]) {
        state.costSItems2[room].costItems = costItems;
      }
    },
    removeCostItemsAndUpdateList :  (state, { payload }) => {
      state.costSItems2 = state.costSItems2.filter((_, index) => index !== payload);
      // now set all room numbers again so that the room numbers are in order
      state.costSItems2 = state.costSItems2.map((_, index) => ({ room: "Room " + (index + 1), costItems: [] }));
    },
    setTotalCost: (state, action) => {
      state.totalCost = action.payload;
      state.amount = Math.round(parseFloat(action.payload) * 100);
    },
    setBookingData: (state, action) => {
      state.bookingData = [action.payload];
    },
    setGuestInfo: (state, action) => {
      state.guestInfo = action.payload;
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setTermsAndConditionIsOpen: (state, action) => {
      state.termsAndConditionIsOpen = action.payload;
    },
    setPackagesAndRoomTotalCost: (state, action) => {
      state.packagesAndRoomTotalCost = action.payload;
    },
    resetReservationsAggregation: (state) => {
      state.reservationRespData = [];
      state.reservationStatus = null;
      state.expectedReservations = 0;
      state.failedReservations = 0;
    },
    setExpectedReservations: (state, { payload }) => {
      state.expectedReservations = payload || 0;
    },
    setGuestProfileToForm: (state, { payload }) => {
      const {
        mobileNoWithoutCountryCode,
        firstName,
        lastName,
        country,
        name,
        cvv,
        card,
        email,
        zipCode,
        expiryDate,
        countryCodeForMobileNumber,
      } = payload;
      state.formFieldInitialState.email = email || '';
      state.formFieldInitialState.lastName = lastName || '';
      state.formFieldInitialState.firstName = firstName || '';
      state.formFieldInitialState.countryCodeForMobileNumber =
        countryCodeForMobileNumber || '+1';
      state.formFieldInitialState.mobileNoWithoutCountryCode =
        mobileNoWithoutCountryCode || '';

      // CARD DETAILS
      state.formFieldInitialState.name = name || '';
      state.formFieldInitialState.card = card || '';
      state.formFieldInitialState.expiryDate = expiryDate || '';
      state.formFieldInitialState.cvv = cvv || '';
      state.formFieldInitialState.country = country || {
        value: 'US',
        label: 'United States',
      };
      state.formFieldInitialState.zipCode = zipCode || '';
    },
    resetPaymentForm: (state) => {
      state.formFieldInitialState.firstName = '';
      state.formFieldInitialState.lastName = '';
      state.formFieldInitialState.email = '';
      state.formFieldInitialState.countryCodeForMobileNumber = '+1';
      state.formFieldInitialState.mobileNoWithoutCountryCode = '';
      state.formFieldInitialState.name = '';
      state.formFieldInitialState.card = '';
      state.formFieldInitialState.expiryDate = '';
      state.formFieldInitialState.cvv = '';
      state.formFieldInitialState.country = {
        value: 'US',
        label: 'United States',
      };
      state.formFieldInitialState.zipCode = '';
    },
    setReservationStatus: (state, action) => {
      state.reservationStatus = action.payload;
    },
    setUserProfileNotFoundGPay: (state, { payload }) => {
      state.isUsrProfileNotFoundGpay = payload;
    },
    // -------- Additional Guests state management --------
    initAdditionalGuests: (state, { payload }) => {
      const length = Math.max(payload || 0, 0);
      const ensure = (existing) => ({
        firstName: existing?.firstName || '',
        lastName: existing?.lastName || '',
        email: existing?.email || '',
        countryCodeForMobileNumber: existing?.countryCodeForMobileNumber || '+1',
        mobileNoWithoutCountryCode: existing?.mobileNoWithoutCountryCode || '',
      });
      const next = new Array(length).fill(null).map((_, i) => ensure(state.additionalGuests?.[i]));
      state.additionalGuests = next;
    },
    setAdditionalGuestField: (state, { payload }) => {
      const { roomIndex, field, value } = payload || {};
      if (typeof roomIndex !== 'number') return;
      if (!state.additionalGuests[roomIndex]) {
        state.additionalGuests[roomIndex] = {
          firstName: '',
          lastName: '',
          email: '',
          countryCodeForMobileNumber: '+1',
          mobileNoWithoutCountryCode: '',
        };
      }
      state.additionalGuests[roomIndex][field] = value;
      // clear specific field error when user types
      if (state.additionalGuestErrors?.[roomIndex]) {
        state.additionalGuestErrors[roomIndex] = {
          ...state.additionalGuestErrors[roomIndex],
          [field]: '',
        };
      }
    },
    setConnectingRoomsPreferred: (state, { payload }) => {
      state.connectingRoomsPreferred = Boolean(payload);
    },
    // set per-room validation errors for additional guests
    setAdditionalGuestErrors: (state, { payload }) => {
      state.additionalGuestErrors = payload || [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(makeTokenization.pending, (state) => {
        state.data = {};
        state.loading = true;
      })
      .addCase(makeTokenization.fulfilled, (state, { payload }) => {
        // state.loading = false;
        state.status = payload.status;
        state.data = payload.tokenizedData;
      })
      .addCase(makeTokenization.rejected, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
      })
      .addCase(makePayment.pending, (state) => {
        state.loading = true;
        state.paymentResData = {};
      })
      .addCase(makePayment.fulfilled, (state, { payload }) => {
        // state.loading = false;
        state.status = payload.status;
        state.paymentResData = payload.paymentResData;
      })
      .addCase(makePayment.rejected, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
      })
      .addCase(makeReservation.pending, (state) => {
        state.loading = true;
        // keep aggregation in progress
      })
      .addCase(makeReservation.fulfilled, (state, { payload }) => {
        state.status = payload.status;
        const index = payload?.index ?? state.reservationRespData.length;
        const updated = [...state.reservationRespData];
        updated[index] = payload.reservationRespData;
        state.reservationRespData = updated;
        // compute overall status only when all attempts are done
        const successCount = updated.filter(Boolean).length;
        const total = state.expectedReservations || updated.length + state.failedReservations;
        const isAllDone = successCount + state.failedReservations >= total && total > 0;
        if (isAllDone) {
          state.reservationStatus = successCount > 0;
          state.loading = false;
        } else {
          state.loading = true;
        }
      })
      .addCase(makeReservation.rejected, (state, { payload }) => {
        // keep loader until all done
        state.status = payload.status;
        state.failedReservations = (state.failedReservations || 0) + 1;
        const successCount = state.reservationRespData.filter(Boolean).length;
        const total = state.expectedReservations || state.reservationRespData.length + state.failedReservations;
        const isAllDone = successCount + state.failedReservations >= total && total > 0;
        if (isAllDone) {
          state.reservationStatus = successCount > 0;
          state.loading = false;
        } else {
          state.loading = true;
        }
      });
  },
});

export const {
  setIsChecked,
  setSignInOpen,
  setOpenPayInfo,
  setIsSignInOption,
  setBookingData,
  setTotalCost,
  setPaymentMethod,
  setPaymentMode,
  setGuestInfo,
  setStatus,
  setCostSItems,
  setCostSItems2,
  resetPaymentForm,
  setCancellationIsOpen,
  // setPetIsOpen,
  setGuestProfileToForm,
  setPackagesAndRoomTotalCost,
  setUserProfileNotFoundGPay,
  setTermsAndConditionIsOpen,
  setReservationStatus,
  updateCostItems,
  removeCostItemsAndUpdateList,
  resetReservationsAggregation,
  setExpectedReservations,
  initAdditionalGuests,
  setAdditionalGuestField,
  setConnectingRoomsPreferred,
  setAdditionalGuestErrors,
} = costSummarySlice.actions;

export const costSummarySelector = (state) => state.costSummary;

export default costSummarySlice.reducer;
